class MatteraDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this._updating = false;
    this.update();
    this.interval = setInterval(() => this.update(), 60000);

    // Vigila si el sistema de "morphing" del tema borra nuestro texto
    // al re-renderizar el carrito, y lo vuelve a rellenar si pasa.
    this.observer = new MutationObserver(() => {
      if (this._updating) return;
      const textEl = this.querySelector('[data-delivery-text]');
      if (textEl && !textEl.querySelector('.cart__delivery-line')) {
        this.update();
      }
    });
    this.observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
    if (this.observer) this.observer.disconnect();
  }

  isBusinessDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  addBusinessDays(date, days) {
    let result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (this.isBusinessDay(result)) added++;
    }
    return result;
  }

  formatDate(date) {
    return date.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  }

  update() {
    const textEl = this.querySelector('[data-delivery-text]');
    if (!textEl) return;

    this._updating = true;

    const CUTOFF_HOUR = 14;
    const now = new Date();
    const beforeCutoff = now.getHours() < CUTOFF_HOUR && this.isBusinessDay(now);

    const expressDate = this.addBusinessDays(now, 1);
    const standardMinDate = this.addBusinessDays(now, 1);
    const standardMaxDate = this.addBusinessDays(now, 3);

    const lines = [];

    if (beforeCutoff) {
      const cutoffTime = new Date(now);
      cutoffTime.setHours(CUTOFF_HOUR, 0, 0, 0);
      const diffMs = cutoffTime - now;
      const hours = Math.floor(diffMs / 3600000);
      const mins = Math.floor((diffMs % 3600000) / 60000);

      // En modo countdown NO repetimos la línea de "Envío Express: recíbelo X"
      // porque la fecha de entrega ya está implícita en este mensaje.
      lines.push(
        '<strong>Envío Express:</strong> pide en las próximas <span class="cart__delivery-highlight">' +
        hours + 'h ' + mins + 'min</span> y recíbelo mañana'
      );
    } else {
      lines.push(
        '<strong>Envío Express:</strong> recíbelo <span class="cart__delivery-highlight">' +
        this.formatDate(expressDate) + '</span>'
      );
    }

    lines.push(
      '<strong>Envío Gratuito a partir de 89 €:</strong> recíbelo entre el <span class="cart__delivery-highlight">' +
      this.formatDate(standardMinDate) + '</span> y el <span class="cart__delivery-highlight">' +
      this.formatDate(standardMaxDate) + '</span>'
    );

    textEl.innerHTML = lines
      .map(function (line) {
        return '<p class="cart__delivery-line">' + line + '</p>';
      })
      .join('');

    // Deja que el DOM se asiente antes de volver a escuchar mutaciones,
    // para no entrar en un bucle infinito con nuestro propio cambio.
    Promise.resolve().then(() => {
      this._updating = false;
    });
  }
}

if (!customElements.get('mattera-delivery-estimate')) {
  customElements.define('mattera-delivery-estimate', MatteraDeliveryEstimate);
}